import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox-item" }
const _hoisted_2 = ["id", "value"]
const _hoisted_3 = ["for"]

import { computed } from 'vue'

interface CheckboxEmits {
  (e: 'update:modelValue', value: Array): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
  id: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit
const model = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: __props.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      type: "checkbox",
      value: __props.value,
      class: "checkbox-item-input"
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, model.value]
    ]),
    _createElementVNode("label", {
      class: "checkbox-item-label _prevent-text-select",
      for: __props.id
    }, _toDisplayString(__props.label), 9, _hoisted_3)
  ]))
}
}

})